import React from "react";
import { useTheme } from "../../theme/ThemeContext";
import { Box, SxProps, Theme } from "@mui/material";

export default function LockIcon({
  width = "32",
  height = "32",
  color = undefined,
  colorReverse = false,
  sx,
}: {
  width?: string;
  height?: string;
  color?: string;
  colorReverse?: boolean;
  sx?: SxProps<Theme>;
}) {
  const theme = useTheme();
  // 支持颜色翻转
  let colorValue = colorReverse ? (theme.isDarkMode ? "#2D3135" : "#F2F2F2") : theme.isDarkMode ? "#F2F2F2" : "#2D3135";
  if(color !== undefined) {
    colorValue = color;
  }
  return (
    <Box component="span" sx={{ ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" fill="none">
        <rect x="5" y="13" width="22" height="15" rx="3" stroke={colorValue} strokeWidth="2" />
        <mask id="path-2-inside-1_7986_1492" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 3C12.134 3 9 6.13401 9 10V14H23V10C23 6.13401 19.866 3 16 3Z"
          />
        </mask>
        <path
          d="M9 14H7V16H9V14ZM23 14V16H25V14H23ZM11 10C11 7.23858 13.2386 5 16 5V1C11.0294 1 7 5.02944 7 10H11ZM11 14V10H7V14H11ZM9 16H23V12H9V16ZM21 10V14H25V10H21ZM16 5C18.7614 5 21 7.23858 21 10H25C25 5.02944 20.9706 1 16 1V5Z"
          fill={colorValue}
          mask="url(#path-2-inside-1_7986_1492)"
        />
        <rect x="15" y="16.5" width="2" height="6" rx="1" fill={colorValue} />
      </svg>
    </Box>
  );
}
